import { render, staticRenderFns } from "./fixRecord.vue?vue&type=template&id=bd820f62&scoped=true"
import script from "./fixRecord.vue?vue&type=script&lang=js"
export * from "./fixRecord.vue?vue&type=script&lang=js"
import style0 from "./fixRecord.vue?vue&type=style&index=0&id=bd820f62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd820f62",
  null
  
)

export default component.exports